export const APRIL_FOOLS_SOLUTION = "(◕‿◕)";

export function isAprilFools() {
  const { month, date } = getCurrentDateEST();
  return month === 3 && date === 1;
}

export function isYesterdayAprilFools() {
  const { month, date } = getCurrentDateEST();
  return month === 3 && date === 2;
}

const UTC_TIME_ZONE_OFFSET = -5;
function getCurrentDateEST() {
  const now = new Date();
  const easternTime = new Date(
    now.getTime() + UTC_TIME_ZONE_OFFSET * 60 * 60 * 1000
  );
  return {
    month: easternTime.getMonth(),
    date: easternTime.getDate(),
  };
}
